import TagsList from './views/TagList'
import TagEdit from './views/TagEdit'
import TagCreate from './views/TagCreate'

export default {
  name:"tags",
  list:TagsList,
  edit:TagEdit,
  create:TagCreate,
}